import React from 'react';
import { motion } from 'framer-motion';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-beige via-white to-sage/10 flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-24 h-24 rounded-2xl flex items-center justify-center mx-auto mb-6 overflow-hidden bg-white border border-sage/20"
        >
          <img
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757895596371-MG-%2B-Wordmark-Logo.jpg"
            alt="MindGarden Logo"
            className="w-full h-full object-contain"
          />
        </motion.div>
        {/* Loading Text */}
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-xl font-cormorant font-bold text-charcoal mb-4"
        >
          Growing Your Garden...
        </motion.h2>
        {/* Loading Animation */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-center justify-center space-x-2"
        >
          {[0, 1, 2].map((index) => (
            <motion.div
              key={index}
              animate={{ scale: [1, 1.2, 1], opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: index * 0.2 }}
              className="w-3 h-3 bg-sage rounded-full"
            />
          ))}
        </motion.div>
        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-charcoal/60 font-dm-sans text-sm mt-4"
        >
          Preparing your mindful productivity experience
        </motion.p>
      </div>
    </div>
  );
}